<div class="faire-page">

  <!-- Header -->
  <div class="faire-header">
    <div class="faire-header-titles">
      <div class="faire-crest">⚜️</div>
      <div>
        <h1>The Grand Faire Chronicle</h1>
        <p class="faire-subtitle">Hark! Plan thy adventures, feasts, and merriment</p>
      </div>
    </div>
    <button class="btn btn-faire-primary" (click)="openFormModal()">⚔️ Proclaim New Quest</button>
  </div>

  <div class="faire-layout" [class.has-panel]="showRightPanel">

    <!-- Left: day groups -->
    <div class="faire-list">
      <div *ngIf="items.length === 0" class="empty-state">
        <div class="empty-scroll">📜</div>
        <p class="empty-message">Thine chronicle lies barren, good traveler.</p>
        <p class="empty-sub">The faire doth await — begin thy planning forthwith!</p>
        <button class="btn btn-faire-primary" (click)="openFormModal()">⚔️ Proclaim thy first quest</button>
      </div>

      <div *ngFor="let day of groupedDays"
           class="day-group"
           [attr.data-drop-date]="day.date"
           [class.drag-over]="dragOverDate === day.date"
           (dragover)="onDragOver($event, day.date)"
           (drop)="onDrop($event, day.date)">
        <div class="day-header" (click)="toggleDay(day.date)">
          <span>⚜️ {{ day.label }}</span>
          <div class="day-header-actions">
            <button class="btn-add-day" (click)="openFormModalForDay(day.date); $event.stopPropagation()" title="Add quest to this day">+</button>
            <span class="collapse-icon" [class.collapsed]="isDayCollapsed(day.date)">▼</span>
          </div>
        </div>
        <div class="day-items" *ngIf="!isDayCollapsed(day.date)">
          <div class="faire-card"
               *ngFor="let item of day.items"
               [class.active]="selectedItem?.id === item.id"
               draggable="true"
               (dragstart)="onDragStart(item)"
               (dragend)="onDragEnd()"
               (touchstart)="onTouchStart($event, item)"
               (click)="openItemModal(item)">
            <div class="card-left">
              <ng-container *ngIf="getCategoryConfig(item.category) as cat">
                <span class="category-badge"
                  [style.background]="cat.bgColor"
                  [style.color]="cat.textColor">
                  {{ cat.emoji }} {{ cat.label }}
                </span>
              </ng-container>
              <span class="item-name">{{ item.name }}</span>
            </div>
            <div class="item-time" *ngIf="item.time">{{ formatTime(item.time) }}</div>
          </div>
        </div>
      </div>

      <!-- Unscheduled items (mobile only) -->
      <div class="undated-panel mobile-undated"
           data-drop-unscheduled="true"
           [class.drag-over]="dragOverUnscheduled"
           (dragover)="onDragOverUnscheduled($event)"
           (drop)="onDropUnscheduled($event)"
           *ngIf="undatedItems.length > 0 || draggingItem?.date">
        <div class="undated-panel-header">
          <span>Quests Awaiting Their Appointed Hour</span>
        </div>
        <div class="undated-empty" *ngIf="undatedItems.length === 0">Drop here to unschedule</div>
        <div *ngFor="let item of undatedItems"
             class="undated-item"
             [class.active]="selectedItem?.id === item.id"
             (touchstart)="onTouchStart($event, item)"
             (click)="openItemModal(item)">
          <div class="card-left">
            <ng-container *ngIf="getCategoryConfig(item.category) as cat">
              <span class="category-badge"
                [style.background]="cat.bgColor"
                [style.color]="cat.textColor">
                {{ cat.emoji }} {{ cat.label }}
              </span>
            </ng-container>
            <span class="item-name">{{ item.name }}</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Right: detail panel + undated items -->
    <div class="right-column" *ngIf="showRightPanel">

      <!-- Detail panel -->
      <div class="detail-panel" *ngIf="selectedItem">
        <div class="detail-panel-header">
          <h5 class="detail-panel-title">{{ selectedItem.name }}</h5>
          <button class="detail-close-btn" (click)="closeItemModal()">✕</button>
        </div>
        <div class="detail-panel-body">
          <ng-container *ngIf="getCategoryConfig(selectedItem.category) as cat">
            <div class="detail-row">
              <span class="detail-label">Nature of Quest</span>
              <span class="category-badge" [style.background]="cat.bgColor" [style.color]="cat.textColor">
                {{ cat.emoji }} {{ cat.label }}
              </span>
            </div>
          </ng-container>
          <div class="detail-row" *ngIf="selectedItem.date">
            <span class="detail-label">Appointed Day</span>
            <span>{{ selectedItem.date | date:'fullDate' }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.time">
            <span class="detail-label">Hour</span>
            <span>{{ formatTime(selectedItem.time) }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.location">
            <span class="detail-label">Whereabouts</span>
            <span>{{ selectedItem.location }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.link">
            <span class="detail-label">Scroll of Knowledge</span>
            <a [href]="selectedItem.link" target="_blank" rel="noopener noreferrer">{{ selectedItem.link }}</a>
          </div>
          <div class="detail-row" *ngIf="selectedItem.cost != null">
            <span class="detail-label">Gold Coin</span>
            <span>{{ selectedItem.cost | currency }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.notes">
            <span class="detail-label">Musings</span>
            <span class="notes-text">{{ selectedItem.notes }}</span>
          </div>
        </div>
        <div class="detail-panel-footer">
          <button class="btn btn-faire-danger" (click)="deleteItem(selectedItem)">Banish</button>
          <button class="btn btn-faire-primary" (click)="openEditModal(selectedItem)">Amend</button>
        </div>
      </div>

      <!-- Undated items -->
      <div class="undated-panel"
           data-drop-unscheduled="true"
           [class.drag-over]="dragOverUnscheduled"
           (dragover)="onDragOverUnscheduled($event)"
           (drop)="onDropUnscheduled($event)"
           *ngIf="undatedItems.length > 0 || draggingItem?.date">
        <div class="undated-panel-header">
          <span>Quests Awaiting Their Appointed Hour</span>
          <span class="undated-hint">drag hither to assign thy day</span>
        </div>
        <div class="undated-empty" *ngIf="undatedItems.length === 0">Drop here to remove from schedule</div>
        <div *ngFor="let item of undatedItems"
             class="undated-item"
             [class.active]="selectedItem?.id === item.id"
             draggable="true"
             (dragstart)="onDragStart(item)"
             (dragend)="onDragEnd()"
             (touchstart)="onTouchStart($event, item)"
             (click)="openItemModal(item)">
          <span class="drag-grip">⠿</span>
          <div class="card-left">
            <ng-container *ngIf="getCategoryConfig(item.category) as cat">
              <span class="category-badge"
                [style.background]="cat.bgColor"
                [style.color]="cat.textColor">
                {{ cat.emoji }} {{ cat.label }}
              </span>
            </ng-container>
            <span class="item-name">{{ item.name }}</span>
          </div>
        </div>
      </div>

    </div>

  </div>

  <!-- Add/Edit Modal -->
  <div class="modal-backdrop" *ngIf="showFormModal">
    <div class="modal-dialog-centered modal-faire-form">
      <div class="modal-content faire-modal-content">
        <div class="modal-header faire-modal-header">
          <h5 class="modal-title">
            {{ editingItemId ? '📜 Amend the Sacred Record' : '⚔️ Inscribe New Quest upon the Scroll' }}
          </h5>
          <button type="button" class="detail-close-btn" (click)="closeFormModal()">✕</button>
        </div>
        <div class="modal-body faire-modal-body">
          <label class="form-label faire-label">Proclamation *</label>
          <input type="text" class="form-control faire-input mb-3" [(ngModel)]="newItem.name" placeholder="Name thy quest..." required>

          <div class="row g-2 mb-3">
            <div class="col-6">
              <label class="form-label faire-label">Appointed Day</label>
              <input type="date" class="form-control faire-input" [(ngModel)]="newItem.date">
            </div>
            <div class="col-6">
              <label class="form-label faire-label">Hour of Occurrence</label>
              <input type="time" class="form-control faire-input" [(ngModel)]="newItem.time">
            </div>
          </div>

          <label class="form-label faire-label">Nature of Quest</label>
          <div class="category-picker mb-3">
            <button
              *ngFor="let cat of categories"
              type="button"
              class="category-btn"
              [class.selected]="newItem.category === cat.value"
              [style.--cat-bg]="cat.bgColor"
              [style.--cat-text]="cat.textColor"
              (click)="newItem.category = newItem.category === cat.value ? undefined : cat.value">
              {{ cat.emoji }} {{ cat.label }}
            </button>
          </div>

          <label class="form-label faire-label">Scroll of Knowledge (URL)</label>
          <input type="url" class="form-control faire-input mb-3" [(ngModel)]="newItem.link" placeholder="https://...">

          <label class="form-label faire-label">Whereabouts</label>
          <input type="text" class="form-control faire-input mb-3" [(ngModel)]="newItem.location" placeholder="The place or address...">

          <label class="form-label faire-label">Gold Coin Required ($)</label>
          <input type="number" class="form-control faire-input mb-3" [(ngModel)]="newItem.cost" placeholder="0.00" min="0" step="0.01">

          <label class="form-label faire-label">Additional Musings</label>
          <textarea class="form-control faire-input" [(ngModel)]="newItem.notes" rows="3" placeholder="Notes, inklings, observations..."></textarea>

          <div *ngIf="formError" class="faire-error mt-2">{{ formError }}</div>
        </div>
        <div class="modal-footer faire-modal-footer">
          <button class="btn btn-faire-secondary" (click)="closeFormModal()">Abandon</button>
          <button class="btn btn-faire-primary" (click)="saveItem()">
            {{ editingItemId ? '📜 Amend the Record' : '⚔️ Inscribe upon the Scroll' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Huzzah celebration overlay -->
  <div class="huzzah-overlay" *ngIf="showHuzzah">
    <img class="herald herald-left"  src="assets/images/ren-faire/herald2.png"  alt="" aria-hidden="true">
    <span class="huzzah-text">Huzzah!</span>
    <img class="herald herald-right" src="assets/images/ren-faire/herald.png" alt="" aria-hidden="true">
  </div>

  <!-- Detail Modal (mobile only) -->
  <div class="modal-backdrop detail-modal-backdrop" *ngIf="showItemModal && selectedItem">
    <div class="modal-dialog-centered modal-faire-detail">
      <div class="modal-content faire-modal-content">
        <div class="modal-header faire-modal-header">
          <h5 class="modal-title">{{ selectedItem.name }}</h5>
          <button type="button" class="detail-close-btn" (click)="closeItemModal()">✕</button>
        </div>
        <div class="modal-body faire-modal-body">
          <ng-container *ngIf="getCategoryConfig(selectedItem.category) as cat">
            <div class="detail-row">
              <span class="detail-label">Nature of Quest</span>
              <span class="category-badge" [style.background]="cat.bgColor" [style.color]="cat.textColor">
                {{ cat.emoji }} {{ cat.label }}
              </span>
            </div>
          </ng-container>
          <div class="detail-row" *ngIf="selectedItem.date">
            <span class="detail-label">Appointed Day</span>
            <span>{{ selectedItem.date | date:'fullDate' }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.time">
            <span class="detail-label">Hour</span>
            <span>{{ formatTime(selectedItem.time) }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.location">
            <span class="detail-label">Whereabouts</span>
            <span>{{ selectedItem.location }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.link">
            <span class="detail-label">Scroll of Knowledge</span>
            <a [href]="selectedItem.link" target="_blank" rel="noopener noreferrer">{{ selectedItem.link }}</a>
          </div>
          <div class="detail-row" *ngIf="selectedItem.cost != null">
            <span class="detail-label">Gold Coin</span>
            <span>{{ selectedItem.cost | currency }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.notes">
            <span class="detail-label">Musings</span>
            <span class="notes-text">{{ selectedItem.notes }}</span>
          </div>
        </div>
        <div class="modal-footer faire-modal-footer">
          <button class="btn btn-faire-danger me-auto" (click)="deleteItem(selectedItem)">Banish</button>
          <button class="btn btn-faire-secondary" (click)="closeItemModal()">Close</button>
          <button class="btn btn-faire-primary" (click)="openEditModal(selectedItem)">Amend</button>
        </div>
      </div>
    </div>
  </div>

</div>
